// Analytics data for brokers
import { useQuery } from "@tanstack/react-query";
import { getBrokerChartData } from "../../api/routes";
import * as client from "../../client";

export const useChartData = (request: client.BrokerAnalyticsData) => {
  return useQuery({
    queryKey: ["broker-analytics", request],
    queryFn: () => getBrokerChartData(request),
    refetchOnWindowFocus: false,
    // Refetch the data at most every 5 minutes:
    staleTime: 1000 * 60 * 5,
  });
};
